
import { useCharteForm } from "./useCharteForm";
import { CharteForm } from "./CharteForm";
import { EmailConfirmation } from "./EmailConfirmation";
import { CharteSignatureFormProps } from "./types";

export const CharteSignatureFormContainer = ({ onSuccess }: CharteSignatureFormProps) => {
  const { form, isSubmitting, emailSent, onSubmit } = useCharteForm(onSuccess);

  if (emailSent) {
    return <EmailConfirmation />;
  }

  return <CharteForm form={form} onSubmit={onSubmit} isSubmitting={isSubmitting} />;
};
